module.exports = __webpack_public_path__ + "static/media/maestro.123f3f9c.png";